export const AddressLanguages = [
    'de', // German
    'en', // English
    'es', // Spanish
    'it', // Italian
    'nl', // Dutch
    'pl', // Polish
    'fr', // French
];
